import { memberReportSchema } from 'store/schemas/database.schemas';
import { putDatabase } from 'store/actions/database.actions';
import { normalize } from 'normalizr';
import { actionCreators as reservationActionCreators } from 'store/actions/metaDatabase.reservations.actions';
import MemberReportsRepository from 'services/repositories/MemberReportsRepository';
import { reservationTableIncludes } from 'store/dispatchers/reservations.dispatchers';
import { actionCreators } from '../actions/metaDatabase.memberReports.actions';
import { buildMetaReportsSelector } from '../selectors/memberReports.selector';

export function loadSales()
{
    return async (dispatch, getState) =>
    {
        const reportId = 'sales_report';
        const metaReportsSelector = buildMetaReportsSelector();
        const metaEntity = metaReportsSelector(getState(), reportId);

        if (metaEntity.loading) return;

        dispatch(actionCreators._loading(reportId, true, []));

        const repository = new MemberReportsRepository();
        const result = await repository.loadSales();

        const report = { id: reportId, data: { ...result.response } };
        const schemaResult = normalize(report, memberReportSchema);
        dispatch(putDatabase(schemaResult.entities));
        dispatch(actionCreators._loading(reportId, false, []));
    };
}

export function loadNumberOfBookings()
{
    return async (dispatch, getState) =>
    {
        const reportId = 'bookings_report';
        const metaReportsSelector = buildMetaReportsSelector();
        const metaEntity = metaReportsSelector(getState(), reportId);

        if (metaEntity.loading) return;

        dispatch(actionCreators._loading(reportId, true, []));

        const repository = new MemberReportsRepository();
        const result = await repository.loadNumberOfBookings();
        const report = { id: reportId, data: { ...result.response } };
        const schemaResult = normalize(report, memberReportSchema);
        dispatch(putDatabase(schemaResult.entities));
        dispatch(actionCreators._loading(reportId, false, []));
    };
}

export function loadTopHotels(period)
{
    return async (dispatch, getState) =>
    {
        const reportId = `top_hotels_report_${period}`;
        const metaReportsSelector = buildMetaReportsSelector();
        const metaEntity = metaReportsSelector(getState(), reportId);

        if (metaEntity.loading) return;

        dispatch(actionCreators._loading(reportId, true, []));
        const repository = new MemberReportsRepository();
        const result = await repository.loadTopHotels(period);
        dispatch(actionCreators._loading(reportId, false, []));
        dispatch(actionCreators._filters(reportId, { loaded: true }));

        const report = { id: `top_hotels_report_${period}`, data: { ...result.response } };
        const schemaResult = normalize(report, memberReportSchema);
        dispatch(putDatabase(schemaResult.entities));
    };
}

export function loadTopDestinations(period)
{
    return async (dispatch, getState) =>
    {
        const reportId = `top_destinations_report_${period}`;
        const metaReportsSelector = buildMetaReportsSelector();
        const metaEntity = metaReportsSelector(getState(), reportId);

        if (metaEntity.loading) return;

        dispatch(actionCreators._loading(reportId, true, []));

        const repository = new MemberReportsRepository();
        const result = await repository.loadTopDestinations(period);

        dispatch(actionCreators._loading(reportId, false, []));
        dispatch(actionCreators._filters(reportId, { loaded: true }));

        const report = { id: reportId, data: { ...result.response } };
        const schemaResult = normalize(report, memberReportSchema);
        dispatch(putDatabase(schemaResult.entities));
    };
}

export function getClosingRatio(memberId)
{
    return async (dispatch, getState) =>
    {
        const reportId = `closing_ratio_${memberId}`;
        const metaReportsSelector = buildMetaReportsSelector();
        const metaEntity = metaReportsSelector(getState(), reportId);

        if (metaEntity.loading) return;

        dispatch(actionCreators._loading(reportId, true, []));

        const repository = new MemberReportsRepository();
        const result = await repository.getClosingRatio(memberId);

        dispatch(actionCreators._loading(reportId, false));

        if (!result.isSuccess())
        {
            dispatch(actionCreators._error(reportId, result.mergeMessages()));
            return;
        }

        const report = { id: reportId, data: result.response };
        const schemaResult = normalize(report, memberReportSchema);
        dispatch(putDatabase(schemaResult.entities));
    };
}

export function loadCommissionReceived()
{
    return async (dispatch, getState) =>
    {
        const reportId = 'commission_received_report';
        const metaReportsSelector = buildMetaReportsSelector();
        const metaEntity = metaReportsSelector(getState(), reportId);

        if (metaEntity.loading) return;
        dispatch(actionCreators._loading(reportId, true, []));

        const memberReportsRepository = new MemberReportsRepository();
        const result = await memberReportsRepository.getCommissionReceived({ includes: reservationTableIncludes });
        dispatch(actionCreators._loading(reportId, false, []));
        if (!result.isSuccess())
        {
            dispatch(actionCreators._error(reportId, result.mergeMessages()));
            return;
        }

        const parsedResult = result.response ?? [];
        const report = { id: 'commission_received_report', reservations: result.response };
        const schemaResult = normalize(report, memberReportSchema);
        dispatch(putDatabase(schemaResult.entities));

        Object.values(parsedResult).forEach((reservation) =>
        {
            dispatch(reservationActionCreators._setLoadedIncludes(reservation.id, reservationTableIncludes));
        });
    };
}
